import React, { useState } from 'react'

import { QuestionAiReview } from '@models/aiGeneration.model'

// A questão como a banca a publicou, ao lado da que a conversão produziu.
//
// A conversão reescreve: uma questão de múltipla escolha com cinco alternativas
// vira uma assertiva de verdadeiro ou falso, e a alternativa que deu origem a
// ela desaparece dentro do texto novo. Sem o original à mão, julgar se a
// reescrita preservou o que a banca cobrava exige abrir o PDF do caderno e
// procurar a questão pelo número — trabalho que ninguém faz vinte vezes
// seguidas, e que por isso não é feito.
//
// Fica recolhido por padrão: quem revisa lê primeiro a assertiva e a lei, e só
// consulta o original quando algo não fecha.

interface Props {
	review: QuestionAiReview
}

const styles = {
	panel: 'bg-white rounded-sm shadow-5 px-6 py-5',
	header: 'flex items-center justify-between w-full text-left',
	title: 'text-base font-medium text-dark',
	toggle: 'text-sm text-blue underline underline-offset-2',
	body: 'mt-4 flex flex-col gap-4',
	label: 'text-sm text-gray',
	text: 'text-sm text-dark leading-relaxed whitespace-pre-line',
	answer: 'text-sm text-dark font-medium',
	missing: 'text-sm text-gray italic',
}

export default function SourceQuestion({ review }: Props) {
	const [open, setOpen] = useState(false)

	const hasSource =
		Boolean(review.sourceStatement) || Boolean(review.sourceAlternatives)

	if (!hasSource) {
		return null
	}

	return (
		<div className={styles.panel}>
			<button
				type='button'
				className={styles.header}
				onClick={() => setOpen(!open)}
			>
				<span className={styles.title}>
					Questão original
					{review.sourceNumber === null
						? ''
						: `, nº ${String(review.sourceNumber)} do caderno`}
				</span>

				<span className={styles.toggle}>{open ? 'Ocultar' : 'Mostrar'}</span>
			</button>

			{open && (
				<div className={styles.body}>
					{review.sourceStatement && (
						<div>
							<span className={styles.label}>Enunciado</span>
							<p className={styles.text}>{review.sourceStatement}</p>
						</div>
					)}

					{review.sourceAlternatives && (
						<div>
							<span className={styles.label}>Alternativas</span>
							<p className={styles.text}>{review.sourceAlternatives}</p>
						</div>
					)}

					<div>
						<span className={styles.label}>Gabarito da banca</span>

						{review.sourceAnswer ? (
							<p className={styles.answer}>{review.sourceAnswer}</p>
						) : (
							/*
							 * Gabarito ausente não é detalhe: quando o caderno não o
							 * traz — ou quando o bloco certo do gabarito não foi
							 * identificado —, a resposta da assertiva foi deduzida da
							 * lei, e não lida da banca. É o caso que mais precisa de
							 * leitura atenta, e o que menos se anuncia sozinho.
							 */
							<p className={styles.missing}>
								Não identificado no caderno: a resposta foi deduzida da lei
							</p>
						)}
					</div>
				</div>
			)}
		</div>
	)
}
